module.exports = __webpack_public_path__ + "img/liantai_logo.984e4429.png";